module.exports = __webpack_public_path__ + "amcharts/images/dragIconRectSmallH.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRectSmallH.svg
// module id = 245
// module chunks = 0